import JSBridge from "../bridge";
import { getAppBaseInfo, isInDocoiApp } from '../utils/app';
import { h5OpenAppPage } from '../utils/redirect';
import { objectToUrlParams } from '../utils/url';
import { useRouter } from "vue-router";
import { getRouterInstance } from "../utils/router";

type RouterRow = {
  path?: string;
  url?: string;
  query?: any;
  type?: 1 | 2 | 4; // 1 跳转普通h5，导航栏原生的 2 跳转小程序 3 动态详情 4 沉浸式（这里只有1，2，4）
};
export default function useRedirect() {
  let isApp = !!getAppBaseInfo();
  let router;

  try {
    router = useRouter();
  } catch (error) {
    // 如果useRouter()失败，使用我们的兜底方案
    console.warn("useRouter() 不可用，使用兜底方案获取router实例:", error);
    router = getRouterInstance();
  }

  let fullLink: DaokeUrlSchemeType = '' as DaokeUrlSchemeType;
	const redirectToMini = (params: RouterRow) => {
		redirect({ ...params, type: 2 });
	};
	const redirectToImmerse = (params: RouterRow) => {
		redirect({ ...params, type: 4 });
	};
	const redirectToH5 = (url: string, type = 1) => {
		fullLink = `daoke://page?type=5&h5Type=${type}&url=${encodeURIComponent(url)}`;
		redirect(fullLink);
	};
	const back = () => {
		if ((!!history.state.back && history.state.back !== history.state.current) || !isInDocoiApp()) {
			if (router) {
				router.back();
			} else {
				console.warn('Router实例不可用，使用浏览器原生返回');
				if (typeof window !== 'undefined' && window.history) {
					window.history.back();
				}
			}
		} else {
			JSBridge.call('closeWebView');
		}
	};
	const openPay = (params: { url: string }) => {
		JSBridge.call('openInExternalBrowser', { ...params });
	};
	const redirect = (params: DaokeUrlSchemeType | RouterRow) => {
		// params string 传整个daoke://page?type=5&h5Type=1&url=
		// params object { path: string, query: object, type: 1 | 2 | 4 }
		if (typeof params == 'object') {
			const { path, query, type = 4, url: url2 } = params;
			if (!isApp) {
				if (router) {
					router.push({ path: path, query: query });
				} else {
					console.warn('Router实例不可用，无法进行路由跳转');
				}
				return;
			}
			console.log('query', objectToUrlParams(query));
			let url = url2 || `${window.location.origin}${path}?${objectToUrlParams(query)}`;
			fullLink = `daoke://page?type=5&h5Type=${type}&url=${encodeURIComponent(url)}`;
		} else {
			fullLink = params;
		}
		h5OpenAppPage(fullLink);
	};
  return {
    toMini: redirectToMini,
    toImmerse: redirectToImmerse,
    toH5: redirectToH5,
    to: redirect,
    back,
    openPay
  };
}

export { useRedirect };
